const env = import.meta.env;

export const amplifyConfigData = {
  Auth: {
    mandatorySignIn: true,
    region: env.VITE_AWS_REGION,
    userPoolId: env.VITE_COGNITO_USER_POOL_ID,
    identityPoolId: env.VITE_COGNITO_IDENTITY_POOL_ID,
    userPoolWebClientId: env.VITE_COGNITO_APP_CLIENT_ID,
    authenticationFlowType: "CUSTOM_AUTH",
  },
  Storage: {
    AWSS3: {
      bucket: env.VITE_S3_BUCKET,
      region: env.VITE_AWS_REGION,
    },
  },
  API: {
    endpoints: [
      {
        name: env.VITE_API_NAME,
        endpoint: env.VITE_API_GATEWAY_URL,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_TRACKING_GATEWAY_SERVICE,
        endpoint: env.VITE_TRACKING_GATEWAY_URL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL,
        endpoint: env.VITE_API_GATEWAY_URL_CDL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL_DEV,
        endpoint: env.VITE_API_GATEWAY_URL_CDL_DEV,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
    ],
  },
  Analytics: {
    disabled: true,
  },
};

export const amplifyConfigDataNewSetUp = {
  Auth: {
    mandatorySignIn: true,
    region: env.VITE_AWS_REGION,
    userPoolId: env.VITE_COGNITO_USER_POOL_ID,
    identityPoolId: env.VITE_COGNITO_IDENTITY_POOL_ID,
    userPoolWebClientId: env.VITE_COGNITO_APP_CLIENT_ID,
  },
  Storage: {
    AWSS3: {
      bucket: env.VITE_S3_BUCKET,
      region: env.VITE_AWS_REGION,
    },
  },
  API: {
    endpoints: [
      {
        name: env.VITE_API_NAME,
        endpoint: env.VITE_API_GATEWAY_URL_V2,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_TRACKING_GATEWAY_SERVICE,
        endpoint: env.VITE_TRACKING_GATEWAY_URL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL,
        endpoint: env.VITE_API_GATEWAY_URL_CDL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL_DEV,
        endpoint: env.VITE_API_GATEWAY_URL_CDL_DEV,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
    ],
  },
  Analytics: {
    disabled: true,
  },
};

export const amplifyGoConfigData = {
  Auth: {
    mandatorySignIn: true,
    region: env.VITE_AWS_REGION,
    userPoolId: env.VITE_COGNITO_USER_POOL_ID,
    identityPoolId: env.VITE_COGNITO_IDENTITY_POOL_ID,
    userPoolWebClientId: env.VITE_COGNITO_APP_CLIENT_ID,
  },
  Storage: {
    AWSS3: {
      bucket: env.VITE_S3_BUCKET,
      region: env.VITE_AWS_REGION,
    },
  },
  API: {
    endpoints: [
      {
        name: env.VITE_API_NAME,
        endpoint: env.VITE_API_GATEWAY_URL_G0,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_TRACKING_GATEWAY_SERVICE,
        endpoint: env.VITE_TRACKING_GATEWAY_URL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL,
        endpoint: env.VITE_API_GATEWAY_URL_CDL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL_DEV,
        endpoint: env.VITE_API_GATEWAY_URL_CDL_DEV,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
    ],
  },
  Analytics: {
    disabled: true,
  },
};

export const apiName = env.VITE_API_NAME;
export const apiNameCDL = env.VITE_API_NAME_CDL;
export const apiNameCDLDev = env.VITE_API_NAME_CDL_DEV;

export const amchartLicenseKey = env.VITE_AMCHART_LICENSE_KEY;

export type IAmplifyConfigData = typeof amplifyConfigData;
export type IAmplifyConfigDataNewSetUp = typeof amplifyConfigDataNewSetUp;
export type IAmplifyGoConfigData = typeof amplifyGoConfigData;
export type IAmplifyZpaxSSOConfigData = typeof amplifyZpaxSSOConfigData;
export const APIRoutes = {
  // mix panel error store
  apiMixPanelErrorStore: `/patient-centric-app-v2/mixpanel/log-error`,

  // User Signup:
  apiSignup: `/patient-centric-app-v2/admin/v3/users/complete-signup`,

  // User Agreement
  userAgreement: `/user-agreement/userAgreement`,
  getPatientsList: `/patient-centric-app-v2/clinic/patient_list`,

  // Clinics
  apiMyClinic: `/patient-centric-app-v2/clinic/my-clinic-slim`,
  apiGetClinicFloor: `/patient-centric-app-v2/clinic/{clinic_id}/user-pref/floors`,
  apiSetClinicFloor: `/patient-centric-app-v2/clinic/{clinic_id}/user-pref/floors`,
  apiResidentList: `/patient-centric-app-v2/clinic/patient_list`,
  apiClinicDailyReportClinic: `/patient-centric-app-v2/v2/clinic_report`,

  // Alert
  apiGetAlertListNew: `/patient-centric-app-v2/clinic/{clinic_id}/v2/clinical-alerts`,
  apiGetAlertDetail: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/v3/clinical-alerts/{alert_id}`,
  apiAddAlertComment: `/patient-centric-app-v2/clinic/{clinic_id}/acknowledge/alert/{alert_id}`,
  apiGetPSNAck: `/patient-centric-app-v2/clinic/{clinic_id}/PSN/alert/{alert_id}`,
  apiAddPSNAck: `/patient-centric-app-v2/clinic/{clinic_id}/psn_v2/alert/{alert_id}/ack`,
  apiGetCombinedAlertList: `/patient-centric-app-v2/clinic/{clinic_id}/patients/escalated-flagged/v2`,
  apiGetFlagList: `/patient-centric-app-v2/clinic/{clinic_id}/v2/patients/flagged`,
  apiAddAlertAck: `/patient-centric-app-v2/clinic/{clinic_id}/ack/alerts/v2`,
  apiPatientAlert: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/escalated-flagged/v2`,
  apiGetFlagAlertClinical: `/patient-centric-app-v2/clinic/{clinic_id}/clinical-listing`,
  apiHideFlag: `/patient-centric-app-v2/clinic/{clinic_id}/psn_v2/alert/{flagged_id}/hide`,

  //Dashboard
  apiGetDashboardList: `/patient-centric-app-v2/clinic/{clinic_id}/cip/v2/psn-alerts`,
  apiGetPsnAlertGraphDataList: `/patient-centric-app-v2/clinic/{clinic_id}/patients/daily_rr_graph`,
  apiGetPatientListDashboard: `/patient-centric-app-v2/clinic/{clinic_id}/v2/recent/admissions`,
  apiGetReAdmitRadatMostCritical: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/v2/readmit_radar/most-critical`,

  //s3
  apiGetFileFromS3: "/patient-centric-app-v2/aws/document",

  //support
  apiReportAProblem: `/patient-centric-app-v2/clinic/{clinic_id}/report-problem/cip/customer-support`,
  apiSubmitFeedback: `/patient-centric-app-v2/feedback/cip`,
  apiSubmitRating: `/patient-centric-app-v2/delighted/rating`,

  //push Notifications
  apiStoreToken: `/patient-centric-app-v2/v2/token`,
  apiGetNotificationSettings: `/patient-centric-app-v2/user/v4`,
  apiPutNotificationSettings: `/patient-centric-app-v2/user/preference/notification/v3`,

  //SMS
  apiSendOTP: `/patient-centric-app-v2/twilio/send-otp`,
  apiVerifyOTP: `/patient-centric-app-v2/verify-otp`,
  apiSavePhoneNumber: `/patient-centric-app-v2/user_info/user_phone_number`,

  //report
  apiGetClinicalReport: `/patient-centric-app-v2/clinic/{clinic_id}/daily_reports`,
  apiGetDailyReport: `/patient-centric-app-v2/clinic/{clinic_id}/daily_reports/{daily_report_id}`,
  apiAddReadDailyReport: `/patient-centric-app-v2/clinic/{clinic_id}/daily_reports/{daily_report_id}/read`,
  // report - AI risk report
  apiGetRiskReport: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/v4/gpt/{date}`,
  apiGetReadmitRadar: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/readmit_radar/v4`,
  apiGetRiskReportClinicPreference: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/gpt/clinic_preference`,
  apiGetRiskReportList: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/list/v2`,
  apiAckRiskReport: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/ack/idt_report/{idt_report_id}`,

  // report - AI risk report public routes
  apiGetRiskReportPublicRoute: `/patient-centric-app-v2/idt_reports/link/summaries`,
  apiGetReadmitRadarPublicRoute: `/patient-centric-app-v2/idt_reports/link/readmit_radar`,
  apiGetRiskReportClinicPreferencePublicRoute: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/gpt/clinic_preference`,
  apiGetRiskReportListPublicRoute: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/list-`,
  apiAckRiskReportPublicRoute: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/ack/idt_report/{idt_report_id}-`,

  //patient
  apiGetPatientList: `/patient-centric-app-v2/clinic/{clinic_id}/v2/patients`,
  apiGetPatientEventList: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/v4/events`,
  apiGetPatientSummary: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/v4/patient-chart-summary`,
  apiGetPatientCircadiaVital: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/last-circadia-vitals`,
  apiGetPatientPCCVital: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/last-pcc-vitals`,
  apiGetPatientRespRate: `/patient-centric-app-v2/clinic/{clinic_id}/patients/rr-metrics-psn`,
  apiGetPatientVitalGraph: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/pcc-vitals-history`,
  apiGetPatientRRGraph: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/rr_graph`,
  /** Sleep classifier v1: per-3s-epoch stage CSV (one stage label per 3-second
   *  epoch, ~28k rows/day). The hourly endpoint (`/infer`) is no longer used —
   *  per-hour quality and stage sets are derived client-side from these epoch
   *  counts (see `sleepInferenceBlend.ts`). */
  apiSleepQualityInfer3sV1: `/patient-centric-app-v2/sleep-quality/v1/clinic/{clinic_id}/patient/{patient_id}/infer-3s`,
  /** Generic CDL data export (CSV) — 3s table with column projection and server-side aggregation. */
  apiCdlDataV1: `/patient-centric-app-v2/sleep-quality/v1/clinic/{clinic_id}/patient/{patient_id}/cdl-data`,
  apiGetPatientNotes: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/cip/combined-circadia-notes`,
  apiGetPatientPCCNotes: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/pcc-notes`,
  apiAddPatientNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/v2/notes`,
  // search
  apiGetSearch: `/patient-centric-app-v2/clinic/{clinic_id}/v3/patients`,

  apiGetAllPatientList: `/patient-centric-app-v2/clinic/{clinic_id}/resident/listing`,

  // Get all patients list (room assigned and not assigned) - V2 API
  apiGetAllPatientListV2: `/patient-centric-app-v2/clinic/{clinic_id}/v2/resident/listing`,

  //insights
  apiGetTOCAllowedMonths:
    "/patient-centric-app-v2/clinic/{clinic_id}/TOC/allowed_months",
  apiGetTOPAllowedMonths:
    "/patient-centric-app-v2/clinic/{clinic_id}/TOP/allowed_months",
  apiGetDischargeAllowedMonths:
    "/patient-centric-app-v2/clinic/{clinic_id}/discharge_insights/allowed_months",
  apiGetTOC: "/patient-centric-app-v2/clinic/{clinic_id}/v2/TOC",
  apiGetTOP: "/patient-centric-app-v2/clinic/{clinic_id}/TOP",
  apiGetDischarge:
    "/patient-centric-app-v2/clinic/{clinic_id}/v2/discharge_insights",
  apiGetTOCRootCause:
    "/patient-centric-app-v2/clinic/{clinic_id}/transfer_out/{TO_EVENT_ID}/RCA",

  //CDL Endpoints
  apiPatientGraphData: `/circadia-vitals/patient_processed/{patient_id}/`,
  apiPatientGraphDataV2: `/v2/circadia-vitals/patient_processed/`,
  // Intercom
  apiGetUserHmac: "/patient-centric-app-v2/user/intercom/token",

  // Agora RTC token (backend must return { token: string }; use App Certificate in Agora Console)
  apiGetAgoraToken: "/patient-centric-app-v2/agora/token",

  // Device onboarding: assign device to current user (POST body: { deviceId: string } or { macAddress: string })
  apiAssignDevice: "/patient-centric-app-v2/patient-app/device/assign",

  // Device identity verification: POST device_id + JWS proof from device's local HTTP server
  apiVerifyDevice: "/patient-centric-app-v2/patient-app/device/verify",

  // Register device to clinic before pairing (called silently at start of connect-device flow)
  apiRegisterDevice:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/register-device",

  // Self-signup: called after Cognito signup + email confirm to create the pending DB record
  apiSelfSignup: "/patient-centric-app-v2/patient-app/self-signup",
  apiSelfSignupActivationStatus:
    "/patient-centric-app-v2/patient-app/self-signup/activation-status",
  apiDeviceActivate: "/patient-centric-app-v2/patient-app/device-activate",

  // Circadia IQ
  apiGenerateCircadiaIQ:
    "/patient-centric-app-v2/circadia_iq/v4/{clinic_id}/patient/{patient_id}",
  apiGetCircadiaIQ:
    "/patient-centric-app-v2/circadia_iq/v4/{clinic_id}/patient/{patient_id}/db",

  // bed exits
  apiAddBedExits: `/patient-centric-app-v2/user/bed-exit/settings/v2`,
  apiUpdateBedExitsTime: `/patient-centric-app-v2/user/bed-exit/settings/time`,
  apiUpdateBedExits: `/patient-centric-app-v2/user/bed-exit/settings/toggle/v3`,
  apiGetBedExitSettingsByUserPref: `/patient-centric-app-v2/clinic/{clinic_id}/user/bed-exits`,
  apiGetPatientNotificationSettings: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/bed-exits`,
  apiGetDiagnoses:
    "/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/patient-diagnosis",
  apiUpdatePatientNotificationSettings: `/patient-centric-app-v2/user/bed-exit/settings/v2`,
  apiUpdateCombineBedExits: `/patient-centric-app-v2/user/bed-exit/settings/combine`,

  // Bed Exit Event List
  apiGetBedExitEventList:
    "/patient-centric-app-v2/clinic/{clinic_id}/v2/bed-exit-events",

  apiGetBedExitFacilityReport:
    "/patient-centric-app-v2/clinic/{clinic_id}/bed-exit-comparison",

  // Users
  apiUserBetaFeature: `/patient-centric-app-v2/user/beta-feature`,

  // Setup-app: pending self-signup users (admin-only)
  apiAdminPendingUsers: `/patient-centric-app-v2/admin/v3/users/pending`,
  // Setup-app: activate a pending self-signup user (admin-only)
  apiAdminActivateUser: `/patient-centric-app-v2/admin/v3/users/{cognito_user_id}/activate`,
  // Setup-app: technician-set temporary password — backend resets the
  // user's password to the supplied value AND emails it to them.
  // Resends the welcome invite to a clinic user with a fresh temporary
  // password. Backend sets the password in Cognito AND emails/SMSes the
  // invite. Caller must be in the same clinic and have setup_app_user
  // (or AccountManager) in their roles. Body: `{ password }`.
  apiAdminResendUserInvite: `/patient-centric-app-v2/patient-app/clinic/{clinic_id}/users/{cognito_user_id}/resend-invite`,
  // Setup-app: list registered patient-app users for a clinic
  apiGetClinicUsers: `/patient-centric-app-v2/patient-app/clinic/{clinic_id}/users`,

  // Tracking
  apiTracking: `/`,

  // Summary
  apiGetSummary: `/patient-centric-app-v2/clinic/{clinic_id}/v4/alerts/summary`,

  // IPV
  apiGetIPVNotesList: `/patient-centric-app-v2/clinic/{clinic_id}/v2/ipv_notes?status={status}`,
  apiAddIPVNotesAck: `/patient-centric-app-v2/clinic/{clinic_id}/acknowledge/ipv_note/{note_id}`,

  // Device Issues
  apiPostDeviceIssue: `/patient-centric-app-v2/clinic/{clinic_id}/device-issues`,

  // Home Health apis
  apiGetSinglePatientInfo: "/home_health/patient/{patient_id}",
  apiGetPatientGraphData: "/home_health/patient/{patient_id}/readings",
  apiGetSelectedFacilityPatientList: "/home_health/facility/{clinic_id}/",
  // User Info
  apiUpdateUserInfo: `/patient-centric-app-v2/user/v2/name`,

  // Sales
  apiAddSalesAck: `/patient-centric-app-v2/clinic/{clinic_id}/demo-request`,

  // VitalSync
  apiExtractVitals: `/patient-centric-app-v2/extract-vitals`,
  apiSubmitVitalsToPCC: `/patient-centric-app-v2/pcc/submit`,

  // Enrolment
  apiGetEnrolledPatients: `/pcc_blogger/clinic/{clinic_id}/patients`,
  apiGetPreviouslyEnrolledPatients: `/rtx/patients/status_base_list/{clinic_id}`,
  apiPutEnrollPatient: `/pcc_blogger/enrolment/new/{admission_id}`,
  apiPutExtendEnrollPatient: `/pcc_blogger/enrolment/update/{rtx_enrolment_id}`,

  // PSN v2 Review
  apiPutPSNAcknowledge: `/patient-centric-app-v2/clinic/{clinic_id}/psn_v2/shift_report/{notification_uuid}/ack`,

  apiGetFacilities: "/patient-centric-app-v2/clinics",
  apiAssignFacility: "/patient-centric-app-v2/users/{userId}/clinics",

  // HealthScribe APIs
  healthScribeStartRecording: `/patient-centric-app-v2/healthscribe/recording/start`,
  healthScribeStopRecording: `/patient-centric-app-v2/healthscribe/recording/stop`,
  healthScribeTranscriptionSave: `/patient-centric-app-v2/healthscribe/transcription/save`,
  healthScribeTranscriptionBatchSave: `/patient-centric-app-v2/healthscribe/transcription/batch-save`,
  healthScribeTranscriptionList: `/patient-centric-app-v2/healthscribe/transcription/list`,
  healthScribeTranscriptionCompleteGenerateNarrative: `/patient-centric-app-v2/healthscribe/transcription/complete`,
  healthScribeGetSession: `/patient-centric-app-v2/healthscribe/recording/clinic/{clinic_id}/session/{session_id}`,
  healthScribeListSessions: `/patient-centric-app-v2/healthscribe/recording/clinic/{clinic_id}/sessions`,
  healthScribeS3UploadInit: `/patient-centric-app-v2/healthscribe/s3/upload/init`,
  healthScribeS3UploadPart: `/patient-centric-app-v2/healthscribe/s3/upload/part`,
  healthScribeS3UploadComplete: `/patient-centric-app-v2/healthscribe/s3/upload/complete`,
  healthScribeS3UploadCompleteAudio: `/patient-centric-app-v2/healthscribe/s3/upload/audio`,
  healthScribeS3UploadAbort: `/patient-centric-app-v2/healthscribe/s3/clinic/{clinic_id}/upload/{session_id}/{upload_id}`,
  healthScribeS3UploadStatus: `/patient-centric-app-v2/healthscribe/s3/clinic/{clinic_id}/upload/status/{session_id}/{upload_id}`,

  // Initial Patient Visit (IPV) - Routes needed for getAllPatientsForIPV functionality
  apiGetIPVNotesByClinicID: `/patient-centric-app-v2/clinic/{clinic_id}/ipv_notes?status={status}`,
  apiGetAllIPVNotes: `/patient-centric-app-v2/clinic/{clinic_id}/patients/ipv_notes`,
  apiPostIPVNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ipv_notes`,
  apiGetIPVNotesByPatientID: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ipv_notes`,

  apiPutIPVNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ipv_notes/{ipv_note_id}`,

  apiFetchAssignedDeviceORAssingDeviceToAPatient:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/device", // GET or POST

  // Disconnects a device from the patient it's currently assigned to so
  // the same hardware can be paired with someone else. Caller must be
  // in the same clinic and have setup_app_user (or clinic user_type) in
  // their roles. No request body. Response includes the updated device
  // record (with `patient_id: null`) so the UI can confirm the unlink.
  apiAdminDisconnectDevice:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/device/{device_id}/disconnect",

  // Prescriptions
  apiGetPrescriptions:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/prescriptions",
  apiUploadPrescription:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/prescriptions",
  apiGetPrescriptionById:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/prescriptions/{prescription_id}",
  apiDeletePrescription:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/prescriptions/{prescription_id}",

  // Reminders
  apiGetReminders:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/reminders",
  apiCreateReminder:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/reminders",
  apiGetReminderById:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/reminders/{reminder_id}",
  apiUpdateReminder:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/reminders/{reminder_id}",
  apiDeleteReminder:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/reminders/{reminder_id}",
  apiDeleteAccount:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/account",

  apiGetPatientProfile:
    "/patient-centric-app-v2/patient-app/patients/{patient_id}/profile",
  apiUpdatePatientProfile:
    "/patient-centric-app-v2/patient-app/patients/{patient_id}/profile",

  apiGetDeviceConnectionStatus:
    "/patient-centric-app-v2/patient-app/device/{device_id}/connection-status",

  // Remotely stores ADDITIONAL Wi-Fi credentials on a paired device. Used when
  // a member is about to switch their home network: the caregiver pushes the new
  // SSID/password ahead of time (keep_existing = true) so the device roams onto
  // it automatically without an on-site re-provision. Scoped by clinic + device
  // (no patient_id). Body: { ssid, password, keep_existing, auth_type, username,
  // restart_after_set }.
  apiSetDeviceWifi:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/device/{device_id}/wifi",
} as const;

/**
 * VoIP / device broker base URL. The on-device AI assistant is activated by
 * calling `${voipBrokerUrl}/ai?device_id=<id>` with a Cognito bearer token —
 * this is the same broker the native VoIP plugin talks to, not the Amplify
 * API gateway. Override via VITE_VOIP_BROKER_URL if the host changes.
 */
export const voipBrokerUrl =
  env.VITE_VOIP_BROKER_URL || "https://voip.circadia.link";

export type IAPIRoutes = typeof APIRoutes;
